"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useRegisterDefaultContextPackers;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _react = require("react");

var _registerContextPacker = _interopRequireDefault(require("../../utils/registerContextPacker"));

var _reportNewView = require("../../utils/reportNewView");

var _isWalmartAddToCartUrl = _interopRequireDefault(require("../../utils/isWalmartAddToCartUrl"));

var _getWeSdkVersion = _interopRequireDefault(require("./getWeSdkVersion"));
/* eslint-disable new-cap */
// Register our default we-sdk contexts - app_customevent, and we_sdk


function useRegisterDefaultContextPackers(projectId) {
  var projectIdRef = (0, _react.useRef)(projectId);
  (0, _react.useEffect)(function () {
    projectIdRef.current = projectId;
  }, [projectId]);
  (0, _react.useEffect)(function () {
    // Any event but pixelmon.pixel
    var anyEventButPixelmonRegex = /^(?!pixelmon\\.pixel).*$/; // Register the customapp_event context packer - for all events, but not pixelmon.pixel since that's one of ours

    (0, _registerContextPacker["default"])({
      schema: 'iglu:com.helloeko/customapp_event/jsonschema/1-0-0',
      match: anyEventButPixelmonRegex,
      getData: function getData(context) {
        return {
          customappcontext: (0, _objectSpread2["default"])({}, context)
        };
      }
    });
    var anyEventRegex = /.*/; // Register the we_sdk context packer - this one uses state so it's a bit more complicated

    (0, _registerContextPacker["default"])({
      schema: 'iglu:com.helloeko/we_sdk/jsonschema/1-0-0',
      match: anyEventRegex,
      // Send with any event from we-sdk
      getData: function getData() {
        return {
          wesdkversion: (0, _getWeSdkVersion["default"])(),
          newviewcount: (0, _reportNewView.getNewViewCount)(),
          projectid: projectIdRef.current
        };
      }
    }); // Register the app.interactions context packer

    (0, _registerContextPacker["default"])({
      schema: 'iglu:com.helloeko/app_interactions/jsonschema/1-0-1',
      match: /^app\.interaction(\..+)?$/,
      getData: function getData(_ref) {
        var elementid = _ref.elementid,
            elementtype = _ref.elementtype,
            elementname = _ref.elementname,
            elementplacement = _ref.elementplacement,
            elementurl = _ref.elementurl;
        var packedData = {
          // Required fields
          elementid: typeof elementid === 'string' && elementid || '',
          elementname: typeof elementname === 'string' && elementname || ''
        };

        if (elementtype) {
          packedData.elementtype = String(elementtype);
        }

        if (elementplacement) {
          packedData.elementplacement = String(elementplacement);
        }

        if (elementurl) {
          packedData.elementurl = String(elementurl);
        }

        return packedData;
      }
    }); // Register the "walmart_linkout" context packer

    (0, _registerContextPacker["default"])({
      schema: 'iglu:com.helloeko/walmart_linkout/jsonschema/1-0-0',
      match: 'walmart.linkout',
      getData: function getData() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            url = _ref2.url,
            walmartIds = _ref2.walmartIds,
            walmartId = _ref2.walmartId;

        url = typeof url === 'string' && url || '';
        walmartIds = walmartIds || walmartId;
        return {
          url: url,
          walmartids: Array.isArray(walmartIds) ? walmartIds.map(function (id) {
            return String(id);
          }) : walmartIds ? [String(walmartIds)] : [],
          type: url.startsWith('sms:') ? 'sms' : (0, _isWalmartAddToCartUrl["default"])(url) ? 'addtocart' : 'url'
        };
      }
    });
  }, []);
}